export default "__VITE_PUBLIC_ASSET__1d061fd6__"